import React from "react";
import AuditTrail from "../../../components/AuditTrail";
import { ApiURL } from "../../../services/apiConstants";

export default function AuditPage() {
  return <AuditTrail endpoint={ApiURL.deck_log_audit_log_com} />;
}
